




























































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Ajax from '../../../lib/ajax'
import User from '../../../store/entities/user'
@Component({
    name:'editUser'
})
export default class EditUser extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    user:User=new User();
    // orgs:Array<any> = [];
    secondOrgs: any = [];
    indexBool = true;
    created(){
    }
    mounted(){
    }
    get roles(){
        return this.$store.state.user.roles;
    }
    get units(){
        return this['$store'].state.user.unit;
    }
    get orgs(){
        return this['$store'].state.user.oneOrg;
    }
    save(){
        (this.$refs.userForm as any).validate(async (valid:boolean)=>{
            if(valid){
                delete (this.user as any).idCardNo;
                await this.$store.dispatch({
                    type:'user/update',
                    data:this.user
                });
                (this.$refs.userForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
                this.$Message.success('修改成功!');
            }
        })
    }
    getOrg(value:number){
        alert(4)
        if(value != undefined){
            (this['$refs']['orgRef'] as any).clearSingleSelect();//重置
            this['$store'].dispatch({
                type:"user/getOneOrg",
                data:value
            })
        }
    }
    // 获取二级部门
    changeSecondOrg(value:any) {
        if(!value){
            return;
        }
        if(this.indexBool){
            (this['$refs']['secOrgRef'] as any).clearSingleSelect();//重置
        }
        Ajax.get('/api/services/app/Organization/GetAllChildrenOrganizationByParentIdAsync?id='+value)
            .then( (res: any) => {
                this.secondOrgs = res.data.result;
                this.indexBool = true;
            } )
            .catch( (err: any) => {
                this.$Message.error(err);
            } )
    }
    cancel(){
        (this.$refs.userForm as any).resetFields();
        this.$emit('input',false);
    }
    async visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }else{
            this.indexBool = false;
            this.user = await Util.extend(true,{},this.$store.state.user.editUser);
            this.changeSecondOrg((this.user as any).belongOrganizationId);
        }
    }
    userRule={
        userName:[{required: true,message: '请填写用户名',trigger: 'blur'}],
        name:[{required:true,message: '请填写名称',trigger: 'blur'}],
        emailAddress:[{required:true,message: '请填写邮箱',trigger: 'blur'},{type: 'email'}],
    }
}
